import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    menuWrapper: {
      zIndex: `${theme.zIndex.tooltip + 1} !important`, // overrides inline style provided by Popover
    },
    menuRoot: {
      maxHeight: 386,
    },
    itemLabel: {
      fontSize: theme.typography.pxToRem(14),
    },
  }),
  { name: 'ContextMenuGenerationTool' }
);
